(function () {
    'use strict';

    angular.module("imApp").factory("equipmentGrpsService", ['$ihttp', function ($ihttp) {
        let service = {
            listEquipmentGrpViews: function (parms) {
                return $ihttp.post({
                    method: 2047,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
